import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';

import LinkButton from '../button/LinkButton';

export const ErrorModal = (props) => {
  const {
    title,
    errorMessages,
    onClose,
    onClick,
  } = props;

  const open = !!(errorMessages && errorMessages.length);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : 'visible';
  }, [ open ]);

  // eslint-disable-next-line no-extra-boolean-cast
  return open ? (
    <span onClick={(e) => { onClick && onClick(); e.stopPropagation(); }}>
      <ReactModal
        isOpen={true}
        closeTimeoutMS={300}
        className="dialog error"
        overlayClassName="overlay contentCenter disabled"
        // onRequestClose={onClose}
        // shouldCloseOnOverlayClick
      >
        <div className="modalContainer">
          <div className="modalContent">
            <div className="modalHeader error">
              <div className="modalTitle">{title}</div>
            </div>
            <div className="modalBody error">
              {errorMessages && errorMessages.map((e, i) => (
                <div key={i} className="errorMessage">
                  {e}
                </div>
              ))}
              <div className="errorActions">
                <LinkButton onClick={onClose} buttonType="navigateMin">
                  OK
                </LinkButton>
              </div>
            </div>
          </div>
        </div>
      </ReactModal>
    </span>
  ) : null;
};

ErrorModal.defaultProps = {
  title: 'エラー',
};

ErrorModal.propTypes = {
  title: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  errorMessages: PropTypes.array,
};

export default ErrorModal;
